import { onBeforeUpdate as r } from "vue";
function c(e) {
  return window.TouchEvent && e instanceof window.TouchEvent;
}
function f() {
  const e = /* @__PURE__ */ new Map(), n = (o) => (t) => {
    e.set(o, t);
  };
  return r(() => {
    e.clear();
  }), [e, n];
}
export {
  c as isTouchEvent,
  f as useRefs
};
